import request from './api';
import { UserInfo } from './type';
import { CreateOrderType } from './type';
import { ZoneType, getArgFromUrl } from '@dana/components';

export const getUserById = async (userId: string): Promise<UserInfo | undefined> =>
  await request('GET', `/account/user/getUserByDanaId?danaId=${userId}`);

export const getZone = async (): Promise<ZoneType[] | undefined> =>
  await request('GET', `/guild/zone/cfg/getAll`);

export const createOrder = async (data: CreateOrderType): Promise<any> => {
  const rechargeAgent = getArgFromUrl('rechargeAgent');
  const needRechargeAgent = rechargeAgent === '1';
  const callbackUrl = new URL(`${window.location.origin}${window.location.pathname}`);

  if (needRechargeAgent) {
    callbackUrl.searchParams.set('rechargeAgent', '1');
  }

  const payload = { ...data, frontCallbackUrl: callbackUrl.toString() };

  return await request('POST', `/payment/order/payermax/create`, payload);
};
